import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";

export const arrowLeft = ({ size = 15, color = "white" }) => {
  return <KeyboardArrowLeftRoundedIcon sx={{ color: color, ml: "0.08rem" }} />;
};
